import * as React from 'react';
import { Component } from 'react';
import { observer } from 'mobx-react';
import { withTheme } from 'styled-components';
import Column from './Column';
import { computed } from 'mobx';
import { DataStore } from '../stores';
import { inject } from '../utils';
import { ColumnConfig } from '../models/configuration/explorer/ColumnConfig';

interface GroupedColumnProps {
    theme?: { [key: string]: React.CSSProperties };
    dataStore?: DataStore;
    column: ColumnConfig;
    columnIndex: number;
    groupedColumnType: string;
}

@inject('dataStore')
@observer
class GroupedColumn extends Component<GroupedColumnProps> {
    constructor(props) {
        super(props);

        if (this.props.column.groups) {
            this.columnStore.setInitialGroupIndex(
                this.props.columnIndex,
                this.props.column
            );
        }
    }

    @computed
    get columnStore() {
        return this.props.dataStore.columnStore;
    }

    @computed
    get selectedGroupIndex() {
        return this.columnStore.getSelectedGroupIndex(
            this.props.columnIndex,
            this.props.column.groups
        );
    }

    @computed
    get column() {
        return this.props.column.groups
            ? this.props.column.groups[this.selectedGroupIndex]
            : this.props.column;
    }

    @computed
    get groupedHeader() {
        const { theme } = this.props;
        const { column, selectedGroupIndex } = this;
        return (
            <Column
                column={column}
                selectedGroupIndex={selectedGroupIndex}
                scope="colGroup"
                borderStyle="none"
                padding="16px 8px 0"
                theme={{
                    ...theme,
                    ColumnLabel: {
                        margin: '0 0 0.5em 0',
                        padding: '0 0 0.5em 0',
                        ...theme.ColumnGroupLabel,
                    },
                }}
                colSpan={column.columns.length}
            />
        );
    }

    @computed
    get groupedSubHeader() {
        const { column, props } = this;
        const { theme } = props;
        const { columns } = column;

        if (columns && columns.length > 0) {
            return columns.map((subColumn, subIndex) => (
                <Column
                    key={subIndex}
                    column={subColumn}
                    fontSize="xs"
                    fontFamily="body"
                    fontWeight="regular"
                    padding="0 0 16px 0"
                    scope="col"
                    {...theme.SubColumnHeader}
                    theme={{
                        ...theme,
                        ColumnLabel: {
                            ...theme.ColumnGroupLabel,
                        },
                    }}
                />
            ));
        }
    }

    render() {
        const { groupedColumnType } = this.props;
        if (groupedColumnType === 'GroupedHeader') {
            return this.groupedHeader || null;
        }
        if (groupedColumnType === 'GroupedSubHeader') {
            return this.groupedSubHeader || null;
        }
        return null;
    }
}

export default withTheme(GroupedColumn) as any;



// WEBPACK FOOTER //
// ./src/Components/GroupedColumn.tsx